import { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { getMapId, getSiteListAction, getSiteName } from '../../../store/authSlice';
import { getSiteDetailsAction } from '../../../store/siteSlice';
const PAGE_SIZE = 12;
export const useSiteList = () => {
    // ========== REDUX SELECTORS ==========
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const { loading, response, cachedPages = {}, currentPage } = useSelector(
    //   (state: RootState) => state?.auth?.userSiteList
    // );
    const response = useSelector((state) => state?.auth?.userSiteList?.response);
    const loading = useSelector((state) => state?.auth?.userSiteList?.loading);
    const { response: siteDetailsResponse } = useSelector((state) => state.site.checkSite);
    // ========== LOCAL STATE ==========
    const [current, setCurrent] = useState(1);
    // ========== SIDE EFFECTS ==========
    useEffect(() => {
        const pageNumber = current - 1;
        // Always fetch fresh data from API
        dispatch(getSiteListAction({ pageNumber, pageSize: PAGE_SIZE }));
    }, [dispatch, current]);
    // ========== MEMOIZED VALUES ==========
    const sites = useMemo(() => response?.content || [], [response?.content]);
    const total = useMemo(() => response?.totalElements || 0, [response?.totalElements]);
    // ========== UTILITY FUNCTIONS ==========
    const storeAuthData = useCallback((data) => {
        if (data.mapId)
            localStorage.setItem('mapId', data.mapId);
        if (data.siteName)
            localStorage.setItem('siteName', data.siteName);
    }, []);
    const determineNavigationRoute = useCallback((siteData) => {
        const { draft, address } = siteData || {};
        if (draft && !address) {
            return "/create-site";
        }
        else if (draft && address) {
            return "/building";
        }
        else if (!draft) {
            return "/editor?panel=mapping";
        }
        else {
            return "/dashboard";
        }
    }, []);
    // ========== HANDLERS ==========
    const handlePageChange = useCallback((page) => {
        setCurrent(page);
    }, []);
    const handleSiteClick = useCallback(async (siteId) => {
        try {
            const resultAction = await dispatch(getSiteDetailsAction(siteId));
            if (getSiteDetailsAction.fulfilled.match(resultAction)) {
                const siteResponse = resultAction.payload;
                if (siteResponse?.status === 200) {
                    const { draft, address, mapId, siteName } = siteResponse.data || {};
                    // Store auth data
                    storeAuthData({ mapId, siteName });
                    dispatch(getMapId(mapId));
                    dispatch(getSiteName(siteName));
                    const navigationRoute = determineNavigationRoute(siteResponse.data);
                    // Navigate to determined route
                    setTimeout(() => navigate(navigationRoute), 1000);
                }
            }
        }
        catch (error) {
            console.error('Error fetching site details:', error);
            message.error('Failed to load site details. Please try again.');
        }
    }, [dispatch, navigate, storeAuthData, determineNavigationRoute]);
    const handleBackToOrganisations = useCallback(() => {
        navigate("/organisations");
    }, [navigate]);
    return {
        // State
        loading,
        sites,
        total,
        current,
        // Handlers
        handlePageChange,
        handleSiteClick,
        handleBackToOrganisations,
    };
};
